<div class="alert-wrapper" data-click-outside-ignore>
  <div
    class="alert-container"
    *ngFor="let alert of alerts(); trackBy: trackById"
    [ngClass]="[alert.type, alert.closing ? 'closing' : '']">
    <div class="alert-content">
      <span class="icon" *ngIf="alert.type === 'success'">
        <i class="bi bi-check-circle-fill"></i>
      </span>
      <span class="icon" *ngIf="alert.type === 'error'">
        <i class="bi bi-x-circle-fill"></i>
      </span>
      <span class="icon" *ngIf="alert.type === 'info'">
        <i class="bi bi-info-circle-fill"></i>
      </span>
      <span class="icon" *ngIf="alert.type === 'warning'">
        <i class="bi bi-exclamation-triangle-fill"></i>
      </span>

      <div class="message">
        <div *ngIf="alert.title as t" class="title">{{ t }}</div>
        <div class="text">{{ alert.message }}</div>
      </div>

      <button class="close-btn" (click)="removeAlert(alert.id)">
        <i class="bi bi-x"></i>
      </button>
    </div>
    <div class="progress-bar"></div>
  </div>
</div>
